
export const MobileParallax = ({ headerImages }) => {
  const image = headerImages?.[0];
  if (!image) return null;
  return (
    <>
      <div className="relative w-[50%] hidden lg:block h-[650px]">
        <img
          className="absolute bottom-0 right-10 h-[650px] w-full object-cover"
          src={image.imageUrl}
          alt={image.alt}
           fetchpriority="high"
        />
      </div>
      <div className="relative h-[400px] md:h-[600px] flex justify-center w-full lg:hidden ">
        <img
          className="block absolute bottom-0 object-cover w-auto md:w-full h-full"
          src={image.imageUrl}
          alt={image.alt}
           fetchpriority="high"
        />
      </div>
    </>
  );
};
